<template>
    <el-dialog
        :title="title"
        :visible.sync="visible"
        :close-on-click-modal="false"
        :before-close="handleBeforeClose"
        append-to-body
        @open="handleOpen"
    >
        <div class="h-content">
            <div class="h-rowBox">
                <el-form :model="f" label-position="right" ref="f" :inline="true" :rules="rules"
                         class="demo-ruleForm h-formbLine h-formbLine1">
                    <div class="h-rowCon">

                        <div class="h-pieceIn2 hang">
                            <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                <h1>新增改制目录</h1>
                            </div>
                            <div class="h-pieceCon2">
                                <div class="create-reform-catalog">
                                    <el-form-item  label="产品大类编码" class="h-elformWrap-2" label-width="100" prop="oneLId" :rules="[{ required: true, message: '请选择产品大类', trigger: 'blur'},]">
                                        <el-select value-key="id" filterable  v-model="saveData.oneLId" placeholder="请选择" @change="getOneLName">
                                            <el-option v-for="item in allOne" :key="item.oneLId"  :label="`[${item.oneLId}] ${item.oneLName}`" :value="item.oneLId"  >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="产品大类名称" class="h-elformWrap-2" required>
                                        <el-input placeholder="选择产品大类编码自动带出" v-model="saveData.oneLName" readonly></el-input>
                                    </el-form-item>
                                    <el-form-item label="链群" class="h-elformWrap-2" :rules="[{ required: true, message: '请选择链群', trigger: 'blur'},]">
                                        <el-select v-model="saveData.lianqunCode" placeholder="请选择" @change="getLianqunName">
                                            <el-option v-for="item in allLianqun" :key="item.lianqunCode" :label="item.lianqunName" :value="item.lianqunCode">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="改制目录名称" class="h-elformWrap-2" required>
                                        <el-input placeholder="请输入" v-model="saveData.specificDivision"></el-input>
                                    </el-form-item>
                                    <el-form-item label="改制要求" class="h-elformWrap-2" :rules="[{ required: true, message: '必须输入选项', trigger: 'blur'},]">
                                        <el-input placeholder="请输入" v-model="saveData.specificReform"></el-input>
                                    </el-form-item>
                                    <el-form-item label="改制类型" class="h-elformWrap-2" required>
                                        <el-select v-model="saveData.specificType" placeholder="请选择" :clearable="true">
                                            <el-option value="1" label="内销"></el-option>
                                            <el-option value="2" label="外销"></el-option>
                                            <el-option value="3" label="内外销通用"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="单台加价" class="h-elformWrap-2" :rules="[{ required: true, message: '必须输入单台加价', trigger: 'blur'},]">
                                        <el-input placeholder="请输入" v-model.number="saveData.reformPrice" ></el-input>
                                    </el-form-item>
                                    <el-form-item label="备注" class="h-elformWrap-2">
                                        <el-input v-model="saveData.remark"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-form>
            </div>
            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="handleBeforeClose">返回</el-button>
                <el-button class="h-btn h-bBtn h-bggreen" @click="submitFlage('暂存')">暂存</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="submitFlage('提交')">确认提交</el-button>
            </div>
        </div>
    </el-dialog>
</template>
<script>
    import _ from "loadsh";
    import reduceCost from "@/api/invoice/reduceCost";
    import specificCatalogue from "@/api/reform/specificCatalogue";
    export default {
        name: 'CreateReformCatalog',
        props: {
            // 控制对话框显示/隐藏
            visible: {
                type: Boolean,
                default: false
            },
            // 对话框标题
            title: {
                type: String,
                default: '新建改制目录'
            },
        },
        data() {
            return {
                submitData:[],
                instid: '',
                saveData:{
                    lianqunCode:'',
                    lianqunName:'',
                    oneLId:'',
                    oneLName:'',
                    specificDivision:'',
                    specificReform:'',
                    reformPrice:0,
                    remark:'',
                    specificType:'',
                },
                f: {
                    productModel: '',
                    productCode: ''
                },
                rules:{},
                //存放所有大类，新增改制条目时用
                allOne:[],
                //存放所有的改制大类，新增改制条目时用
                allDivision:[],
                //存放所有链群，新增改制条目时用
                allLianqun:[],
            }
        },
        created() {
            this.clearSaveData();
            this.createSpecific();
        },
        methods:{
            // 清空saveData
            clearSaveData(){
                this.saveData= {
                    lianqunCode:'',
                    lianqunName:'',
                    oneLId:'',
                    oneLName:'',
                    specificDivision:'',
                    specificReform:'',
                    reformPrice:0,
                    remark:'',
                    specificType:'',
                };
            },
            // 处理对话框打开
            handleOpen() {
                this.clearSaveData();
                this.createSpecific();
            },
            // 处理对话框关闭前的逻辑
            handleBeforeClose() {
                this.clearSaveData();
                this.$emit('close');
            },
            submitFlage(data){
                if (this.saveData.specificDivision === '') {
                   return this.$msg.msge("改制目录名称不能为空!");
                }
                if (this.saveData.specificReform === '') {
                    return this.$msg.msge("改制要求不能为空!");
                }
                if (this.saveData.reformPrice === '' || this.saveData.reformPrice === undefined) {
                    return this.$msg.msge("单台加价不能为空!");
                }
                if (this.saveData.specificType === '') {
                    return this.$msg.msge("改制类型不能为空!");
                }
                if (this.saveData.lianqunCode === '') {
                    return this.$msg.msge("链群不能为空!");
                }
                if (this.saveData.oneLId === '') {
                    return this.$msg.msge("产品大类不能为空!");
                }
                if(data === '提交'){
                    this.subTo();
                }else {
                    this.saveTo();
                }
            },
            saveTo() {
                reduceCost.insertReformCatalog(this.saveData).then(rd => {
                    this.$msg.msgs(rd.msg);
                })
            },
            subTo() {
                this.$msg.confirm("确认提交?", () => {
                    reduceCost.submitNew(this.saveData).then(rd => {
                        this.$msg.msgs(rd.msg);
                        if (rd.f) {
                            this.handleBeforeClose();
                        }
                    })
                })
            },
            createSpecific() {
                //查询所有链群
                specificCatalogue.selectAllOne().then(rd => {
                    this.allOne = rd;
                })
            },
            getOneLName(q){
                //获取name
                const one = _.find(this.allOne,{oneLId:q})
                this.saveData.oneLName = one.oneLName;
                this.selectAllDivision(q);
            },
            selectAllDivision(oneLId){
                //查询所有改制目录
                specificCatalogue.selectAllDivision({oneLId: oneLId}).then(rd => {
                    this.allDivision = [];
                    for (let item of rd) {
                        if (this.allDivision.indexOf(item.specificDivision) === -1) {
                            this.allDivision.push(item.specificDivision);
                        }
                    }
                    //过滤出所有可选链群
                    this.allLianqun = [];
                    this.saveData.lianqunCode='';
                    this.saveData.lianqunName='';
                    for (let item of rd) {
                        if (this.allLianqun.findIndex(item => item.lianqunCode=== item.lianqunCode) === -1) {
                            this.allLianqun.push(item);
                        }
                    }
                    this.saveData.lianqunCode = this.allLianqun[0].lianqunCode;
                    this.getLianqunName(this.saveData.lianqunCode);
                })
            },
            getLianqunName(q){
                //获取name
                const lianqun = _.find(this.allLianqun,{lianqunCode:q})

                this.saveData.lianqunName = lianqun.lianqunName;
                console.log("this.saveData.oneLName",this.saveData.lianqunName)
            },
            //返回
            backS() {
                this.$router.push({path: "/invoice/reformCatalogList"});
            },
        },
    }
</script>
<style scoped>
    ::v-deep(.create-reform-catalog .h-elformWrap-2 .el-form-item__label) {
        width: 55%;
        text-align: left;
    }
    ::v-deep(.create-reform-catalog .el-form-item__content) {
        width: 100%;
    }

    .create-reform-catalog .h-elformWrap-2 {
        width: 50% !important;
        padding-right: 0.5rem
    }
    .create-reform-catalog .h-elformWrap-5 {
        width: 74% !important;
        padding-right: 0.5rem
    }

    .create-reform-catalog .h-elformWrap-3 {
        width: 85% !important;
        padding-right: 0.5rem
    }
    .create-reform-catalog .h-elformWrap-3 .el-form-item__label {
        width: 12%;
        text-align: right;
    }
    .create-reform-catalog .h-elformWrap-35 {
        width: 77% !important;
        padding-right: 0.5rem
    }
    .create-reform-catalog .h-elformWrap-35 .el-form-item__label {
        width: 20%;
        text-align: right;
    }
    .create-reform-catalog .h-elformWrap-4 {
        width: 100%;
        padding-right: 0.5rem
    }

    .create-reform-catalog .h-elformWrap-4 .el-form-item__label {
        width: 10%;
    }
    .create-reform-catalog .h-elformWrap-4 .el-form-item__content {
        width: 89%;
    }
    .create-reform-catalog .w-elformWrap {
        width: 100% !important;
    }
    .w-elformWrap .el-form-item__label {
        width: 14% !important;
    }
    .w-elformWrap .el-form-item__content {
        width: 86% !important;
    }
    .create-reform-catalog .h-elformWrap-1 {
        width: 86%;
        padding-right: 0.5rem
    }

    .create-reform-catalog .h-elformWrap-1 .el-form-item__label {
        width: 14%;
    }

    .create-reform-catalog .h-elformWrap-1 .el-form-item__content {
        width: 86%;
    }

    .create-reform-catalog.el-form-item__content .el-select {
        width: 100%;
    }

    .ljjtablepaddings6 .h-tableInput .el-input__inner{
        padding: 0.05rem 0.1rem;
    }
    .ljjtablepaddings6 .h-tableInput .el-input__icon{
        line-height: 0.25rem;
    }
    .bbbb {
        padding-top: 5px;
        margin: 0 20px;
    }

    .hang {
        padding: 20px 0;
        margin-bottom: 0;
        background-color: white;
    }
    .ddform_disable_cls .el-form-item__content .el-input__inner[disabled] {
        color: #868686;
    }
    /* 修复标签换行问题 */
    .create-reform-catalog .el-form-item__label {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    /* 调整输入框宽度 */
    .create-reform-catalog .h-elformWrap-2 .el-form-item__content {
        width: 100% !important;
    }

    /* 统一输入框样式 */
    .create-reform-catalog .el-form-item__content .el-input,
    .create-reform-catalog .el-form-item__content .el-select {
        width: 100%;
    }

    /* 优化按钮间距 */
    .h-txtCenter h-mrt60 {
        margin-top: 40px;
        display: flex;
        justify-content: center;
        gap: 15px;
    }
</style>
